/**
 * TierBadge — canonical membership display.
 *
 * Always renders the category in brand (teal) and the tier in amber, with a
 * muted separator between them. Keep this component as the single source of
 * truth for "PERSONAL / FREE" style pills so the Dashboard, Navbar dropdown,
 * and Settings header stay in sync.
 */

type Size = 'sm' | 'md'

interface Props {
  category: string
  tier: string
  size?: Size
  className?: string
}

const SIZE_STYLES: Record<Size, string> = {
  sm: 'h-6 px-2 text-[10.5px] tracking-wide',
  md: 'h-7 px-2.5 text-xs tracking-wider',
}

export default function TierBadge({ category, tier, size = 'sm', className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 ${SIZE_STYLES[size]} ${className}`}
    >
      <span className="text-brand-600 dark:text-brand-400">{category}</span>
      <span className="text-gray-400 dark:text-gray-600" aria-hidden="true">/</span>
      <span className="text-amber-600 dark:text-amber-400">{tier}</span>
    </span>
  )
}
